exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".talent-pager[data-v-51fc17fa]{float:right;margin-top:16px}\n", ""]);

